var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 20,
    viewBox: "0 0 60 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(-7549 -4384.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 60,
    height: 20,
    rx: 4,
    transform: "translate(7549 4384.25)",
    fill: "#575c77"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Enterprise",
    transform: "translate(7578.999 4397.693)",
    fill: "#0c0f1a",
    fontSize: 10,
    fontFamily: "Gilroy-Semibold, Gilroy",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23,
    y: 0
  }, "Enterprise")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeEnterprise);
export default __webpack_public_path__ + "static/media/badge-enterprise.ef341eea128af6ff98dc5fd860ba60b3.svg";
export { ForwardRef as ReactComponent };